import { useMemo, useState } from 'react';
import SectionHeading from '@/pages/home/components/SectionHeading';
import { directoryCategories, directoryItems } from '@/mocks/home';

export default function UrlDirectory() {
  const [active, setActive] = useState('全部');
  const [keyword, setKeyword] = useState('');

  const filtered = useMemo(() => {
    const k = keyword.trim().toLowerCase();
    return directoryItems.filter((item) => {
      const matchCat = active === '全部' || item.category === active;
      const matchKey =
        k === '' ||
        item.name.toLowerCase().includes(k) ||
        item.desc.toLowerCase().includes(k) ||
        item.category.toLowerCase().includes(k);
      return matchCat && matchKey;
    });
  }, [active, keyword]);

  return (
    <section id="directory" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <SectionHeading
          eyebrow="网址大全"
          title="按分类浏览全部入口"
          desc="把入口按终端与场景归类后，查找会直接很多。可以先选分类，也可以用关键词筛选，结果只作用于本站已整理的内容。"
        />

        <div className="mt-8 md:mt-10 flex flex-col gap-4">
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:justify-between">
            <div className="flex flex-wrap gap-2">
              {directoryCategories.map((cat) => (
                <button
                  key={cat}
                  type="button"
                  onClick={() => setActive(cat)}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer border ${
                    active === cat
                      ? 'bg-primary-500 text-background-50 border-primary-500'
                      : 'bg-background-100 text-foreground-700 border-background-200/70 hover:bg-primary-50 hover:text-primary-700'
                  }`}
                >
                  {cat}
                </button>
              ))}
            </div>

            <div className="relative w-full lg:w-72">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400">
                <i className="ri-search-line text-base"></i>
              </span>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索入口名称或说明"
                aria-label="搜索入口"
                className="w-full pl-10 pr-9 py-2.5 rounded-md bg-background-100 border border-background-200/70 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-300 transition-colors"
              />
              {keyword && (
                <button
                  type="button"
                  aria-label="清空搜索"
                  onClick={() => setKeyword('')}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-foreground-400 hover:text-foreground-700 cursor-pointer"
                >
                  <i className="ri-close-circle-line text-base"></i>
                </button>
              )}
            </div>
          </div>

          <p className="text-xs text-foreground-500">
            共 <span className="font-semibold text-foreground-800">{filtered.length}</span> 条入口记录
            {active !== '全部' && <>，当前分类：{active}</>}
          </p>
        </div>

        {filtered.length > 0 ? (
          <div className="mt-6 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
            {filtered.map((item) => (
              <article
                key={item.name}
                className="rounded-lg bg-background-100 border border-background-200/70 p-6 hover:border-primary-300 transition-colors"
              >
                <div className="flex items-center justify-between gap-3">
                  <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-background-50 text-primary-700 border border-background-200/70">
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <span className="px-2.5 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs font-medium whitespace-nowrap">
                    {item.category}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">{item.name}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                <div className="mt-4 pt-4 border-t border-background-200/70 flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-information-line text-accent-600"></i>
                  {item.meta}
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-8 rounded-lg bg-background-100 border border-background-200/70 py-14 text-center">
            <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-background-50 text-foreground-400">
              <i className="ri-search-eye-line text-2xl"></i>
            </div>
            <p className="mt-4 text-sm text-foreground-600">没有找到匹配的入口记录</p>
            <button
              type="button"
              onClick={() => {
                setKeyword('');
                setActive('全部');
              }}
              className="mt-4 inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-refresh-line"></i>
              重置筛选条件
            </button>
          </div>
        )}
      </div>
    </section>
  );
}